import Button from 'components/Button';
import CloseIcon from 'assets/icons/close.svg';
import CustomModal from 'components/CustomModal';
import warningIcon from 'assets/icons/warning.svg';
import CloseWhiteIcon from 'assets/icons/close-white.svg';

interface ErrorPortCoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ErrorPortCoModal = ({
  isOpen,
  onClose,
  onSubmit
}: ErrorPortCoModalProps) => {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      className='flex flex-col gap-4 max-w-[480px] p-8 rounded-2xl overflow-hidden'
    >
      <img
        alt='Close'
        onClick={onClose}
        src={isDarkMode ? CloseWhiteIcon : CloseIcon}
        className='cursor-pointer absolute top-4 right-4'
      />

      <div className='flex items-center justify-center w-20 h-20 rounded-full bg-[#FDF1F1]'>
        <img src={warningIcon} alt='warning' className='w-12 h-12' />
      </div>

      <p className='font-semibold text-[28px]'>Review invalid data</p>

      <p className='font-light text-base text-[#5C5C5C]'>
        By confirming this dataset, you are submitting it with existing error
        messages. Please review the errors before proceeding.
      </p>

      <div className='flex items-center gap-4 mt-6'>
        <Button
          id='submit'
          label='Submit'
          onClick={onSubmit}
          className='flex-1 px-5 py-2 rounded-5xl text-lg font-light text-center text-black bg-white dark:bg-black dark:text-white hover:bg-gray-300 dark:hover:bg-gray-400 border border-solid border-[#E8E8E8] dark:hover:text-black transition-all duration-300'
        />

        <Button
          id='review'
          label='Review'
          onClick={onClose}
          className='flex-1 px-5 py-2 rounded-5xl text-lg font-light text-center text-white bg-black dark:bg-white dark:text-black hover:bg-[#404040] dark:hover:bg-gray-400 transition-all duration-300'
        />
      </div>
    </CustomModal>
  );
};

export default ErrorPortCoModal;
